import { GC_GET_MEDIA_LIST, GC_GET_MEDIA_BY_ID } from '@/graphql/media'
import apollo from '@/apolloClient'

export default {
    namespaced: true,
    state: {
        list: [],
    },
    mutations: {
        SET_MEDIA_LIST(state, locations) {
            state.list = locations;
        }
    },
    actions: {
        async getList({ commit }) {
            const response = await apollo.query({ query: GC_GET_MEDIA_LIST })

            commit('SET_MEDIA_LIST', response.data.media)
        },
        async getById({ commit }, id) {
            const response = await apollo.query({
                query: GC_GET_MEDIA_BY_ID,
                variables: {
                    id:id
                }
             })
            return response.data.media[0]
            // commit('SET_MEDIA_LIST', response.data.media)
        }
    }
}